/**
 * Primalane Image Banner Component Script
 * Handles responsive height calculation, dynamic lazy image switching, and Shopify Theme Editor events.
 */

(function() {
  'use strict';

  function initImageBanner(section) {
    if (!section) return;

    var desktopImg = section.querySelector('.prm-image-banner__img--desktop');
    var mobileImg = section.querySelector('.prm-image-banner__img--mobile');

    function checkResponsiveImages() {
      var isMobile = window.innerWidth <= 749;
      if (isMobile && mobileImg && mobileImg.getAttribute('data-src')) {
        if (!mobileImg.src) {
          mobileImg.src = mobileImg.getAttribute('data-src');
        }
      } else if (!isMobile && desktopImg && desktopImg.getAttribute('data-src')) {
        if (!desktopImg.src) {
          desktopImg.src = desktopImg.getAttribute('data-src');
        }
      }
    }

    checkResponsiveImages();
    window.addEventListener('resize', checkResponsiveImages, { passive: true });
  }

  function initAllBanners() {
    var sections = document.querySelectorAll('.prm-image-banner-root');
    sections.forEach(function(sec) {
      initImageBanner(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBanners);
  } else {
    initAllBanners();
  }

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.prm-image-banner-root');
    if (section) {
      initImageBanner(section);
    }
  });
})();
